import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconComment$1 = /*@__PURE__*/ proxyCustomElement(class WppIconComment extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-comment", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.37496 4.29163C3.63876 4.29163 3.04163 4.88876 3.04163 5.62496V12.7083C3.04163 13.4445 3.63876 14.0416 4.37496 14.0416H5.62496C6.03917 14.0416 6.37496 14.3774 6.37496 14.7916V17.0416L10.175 14.1916C10.3048 14.0943 10.4627 14.0416 10.625 14.0416H15.625C16.3612 14.0416 16.9583 13.4445 16.9583 12.7083V5.62496C16.9583 4.88876 16.3612 4.29163 15.625 4.29163H4.37496ZM1.54163 5.62496C1.54163 4.06033 2.81033 2.79163 4.37496 2.79163H15.625C17.1896 2.79163 18.4583 4.06033 18.4583 5.62496V12.7083C18.4583 14.2729 17.1896 15.5416 15.625 15.5416H10.875L6.74163 18.6416L6.74148 18.6417C5.97295 19.2178 4.87496 18.6702 4.87496 17.7083V15.5416H4.37496C2.81033 15.5416 1.54163 14.2729 1.54163 12.7083V5.62496Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-comment-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-comment", "wpp-icon-comment-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-comment-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-comment-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconComment$1);
      }
      break;
  } });
}

const WppIconComment = WppIconComment$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconComment, defineCustomElement };
